import type { MouseEvent } from 'react';
import { router } from '@inertiajs/react';

import { useIsPreviewMode } from '@/hooks/use-is-preview-mode';
import { getPublicNavPageUrl, PREVIEW_NAV_MESSAGE } from '@/lib/page-utils';
import { openWindow, postMessageToParent } from '@/lib/utils';

export function usePreviewInternalLinkClick() {
  const isPreview = useIsPreviewMode();

  return (event: MouseEvent<HTMLElement>) => {
    if (event.defaultPrevented || !isPreview || !(event.target instanceof Element)) return;

    const link = event.target.closest<HTMLAnchorElement>('a[data-internal-page-id]');
    const pageId = link?.dataset.internalPageId;
    if (!link || !pageId || !event.currentTarget.contains(link)) return;

    const previewHref = getPublicNavPageUrl({ id: pageId }, { isEditor: false, isPreview: true });
    event.preventDefault();

    if (link.target === '_blank' || event.metaKey || event.ctrlKey) {
      openWindow(previewHref, '_blank', 'noopener,noreferrer');
      return;
    }

    postMessageToParent({ type: PREVIEW_NAV_MESSAGE, pageId });
    router.visit(previewHref);
  };
}
